import type { CustomerRatingsAndReviewsPageSearchParams } from '../../types';

export const getSearchParamsValue = (
  searchParams: URLSearchParams | null | undefined,
  searchParam: CustomerRatingsAndReviewsPageSearchParams,
) => {
  const param = searchParams?.get(searchParam);
  return param ? decodeURIComponent(param) : undefined;
};
